import './assets/styles/main.scss';
import PharmacyRoutes from './routes/PharmacyRoutes';

export default PharmacyRoutes;
